/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Today_Stat_Minutes_LabelInputs */

const en_us2_today_stat_minutes_label = /** @type {(inputs: Today_Stat_Minutes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About ${i?.minutes} minutes`)
};

const pt_br2_today_stat_minutes_label = /** @type {(inputs: Today_Stat_Minutes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cerca de ${i?.minutes} minutos`)
};

const es_419_today_stat_minutes_label = /** @type {(inputs: Today_Stat_Minutes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unos ${i?.minutes} minutos`)
};

const pt_pt2_today_stat_minutes_label = /** @type {(inputs: Today_Stat_Minutes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cerca de ${i?.minutes} minutos`)
};

const fr_fr2_today_stat_minutes_label = /** @type {(inputs: Today_Stat_Minutes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Environ ${i?.minutes} minutes`)
};

const de_de2_today_stat_minutes_label = /** @type {(inputs: Today_Stat_Minutes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Etwa ${i?.minutes} Minuten`)
};

const it_it2_today_stat_minutes_label = /** @type {(inputs: Today_Stat_Minutes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Circa ${i?.minutes} minuti`)
};

/**
* | output |
* | --- |
* | "About {minutes} minutes" |
*
* @param {Today_Stat_Minutes_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_stat_minutes_label = /** @type {((inputs: Today_Stat_Minutes_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Stat_Minutes_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_stat_minutes_label(inputs)
	if (locale === "es-419") return es_419_today_stat_minutes_label(inputs)
	if (locale === "pt-PT") return pt_pt2_today_stat_minutes_label(inputs)
	if (locale === "fr-FR") return fr_fr2_today_stat_minutes_label(inputs)
	if (locale === "de-DE") return de_de2_today_stat_minutes_label(inputs)
	if (locale === "it-IT") return it_it2_today_stat_minutes_label(inputs)
	return en_us2_today_stat_minutes_label(inputs)
});
export { today_stat_minutes_label as "today.stat_minutes_label" }